import { createApi } from "@reduxjs/toolkit/query/react";
import { privateBaseQuery } from "../base/private/privateBaseQuery";

function isRecord(value: unknown): value is Record<string, unknown> {
  return !!value && typeof value === "object" && !Array.isArray(value);
}

/**
 * Backend contract:
 * POST /api/upload.json (private client baseURL already includes `/api`)
 * FormData: file, storage=others, extended=true? (optional)
 * Response:
 * { success: true, data: { src: "https://..." } }
 */
export const mediaApi = createApi({
  reducerPath: "mediaApi",
  baseQuery: privateBaseQuery(),
  endpoints: (builder) => ({
    uploadFile: builder.mutation<
      { src: string },
      { file: File; storage?: string; extended?: boolean }
    >({
      query: ({ file, storage = "others", extended }) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("storage", storage);

        if (extended) {
          formData.append("extended", "true");
        }

        return {
          url: "/upload.json",
          method: "POST",
          data: formData,
        };
      },
      transformResponse: (response: unknown) => {
        // allow both: { src } and { success, data: { src } }
        if (isRecord(response)) {
          const direct = response["src"];
          if (typeof direct === "string") return { src: direct };

          const data = response["data"];
          if (isRecord(data) && typeof data["src"] === "string") {
            return { src: data["src"] };
          }
        }

        return { src: "" };
      },
    }),
  }),
});

export const { useUploadFileMutation } = mediaApi;